<template>
    <div class="div-bg">
        <!-- <img src="../assets/images/login_bg.png" -->
        <!-- style="border: 0;width: 100%;height: 100%;position: absolute;left: 0;top: 0;right: 0;bottom: 0;z-index: -999;"> -->
        <div style="" ref="refLoginDiv" :style="{marginTop:panelMarginTop+'px'}">
            <div style="text-align: center;">
                <img src="../../assets/images/heng_dian.png" alt="" style="width: 270px;height: 55px;">
            </div>
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 1em;">
                <el-card style="width: 620px;">
                    <p style="font-weight: bolder;font-size: 24px;text-align: center;margin-top: 40px;">欢迎注册恒点MOOL
                    </p>
                    <el-form :model="form" ref="refForm">
                        <div style="text-align: center;padding-left: 90px;padding-right: 90px;">
                            <el-form-item prop="username" :rules="[{
                required: true,
                message: '请输入用户名',
                trigger: 'blur'
            },
            {
                min: 6,
                max: 30,
                message: '6-30位字母、数字或者“_”,字母开头',
                trigger: 'blur'
            }]">
                                <el-input placeholder="请输入用户名" prefix-icon="iconfont icon-nan" ref="username"
                                          v-model.trim="form.username">
                                </el-input>
                                <div></div>
                            </el-form-item>
                            <el-form-item prop="password" :rules="[{
                required: true,
                message: '请输入密码',
                trigger: 'blur'
            },{
                min: 6,
                max: 20,
                message: '密码长度6-20位，建议数字和字母组合',
                trigger: 'blur'
            }]">
                                <el-input placeholder="请输入密码" prefix-icon="iconfont icon-key" ref="password"
                                          v-model.trim="form.password" type="password">
                                </el-input>
                            </el-form-item>
                            <el-button type="primary" style="width: 400px;" @click="doRegister()">注册</el-button>
                            <el-row style="color: #999999;margin-top: 10px;font-size: 12px;text-align: right;">
                                <span>已有账号？</span>
                                <router-link class="go-login" :to="{path:'/'}">登录</router-link>
                            </el-row>
                        </div>
                    </el-form>
                </el-card>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdFooter from '../public/Footer.vue'

export default {
    name: 'UserName',
    components: {
        HdFooter
    },
    created () {
        //赋值
        this.cert = localStorage.getItem('cert')
        if (this.isEmail(this.cert)) {
            //非法请求
            console.log('非法访问')
            this.$router.push({
                path: '/'
            })
        }
        this.getPublicKey()
    },
    mounted () {
        let that = this
        this.$nextTick(function () {
            that.setPanelPosition()
        })
        //设置焦点
        this.$refs.username.focus()
    },
    data () {
        return {
            panelMarginTop: 0,
            form: {
                username: '',
                password: ''
            },
            rules: {
                password: []
            },
            cert: '',
            publicKey: '',
            publicMd5: ''
        }
    },
    methods: {
        setPanelPosition () {
            let h = this.$refs.refLoginDiv.offsetHeight
            this.panelMarginTop = this.getClientTop(h)
        },
        getPublicKey () {
            let that = this
            this.$ajax.get('/api/rsa/getpublickey').then(function (res) {
                that.publicKey = res.data.public
                that.publicMd5 = res.data.public_md5
            })
            setTimeout(function () {
                if (that.isEmpty(that.publicKey)) {
                    //再次调用
                    that.getPublicKey()
                }
            }, 3000)
        },
        doRegister: function () {
            let that = this;
            this.$refs.refForm.validate(function (valid) {
                if (valid) {
                    if (that.isEmpty(that.form.username)) {
                        that.$message.error('请输入用户名')
                        return
                    }
                    if (that.isEmpty(that.form.password)) {
                        that.$message.error('请输入密码')
                        return
                    }
                    if (!that.isPasswordAZaz09(that.form.password, 6)) {
                        that.$message.error('请输入至少6位长度的数字和字母组合')
                        return
                    }
                    that.$ajax.post('/api/user/register', {
                        cert: that.cert,
                        password: that.rsaEncode(that.form.password, that.publicKey),
                        username: that.form.username,
                        public_md5: that.publicMd5
                    }).then(function (res) {
                        if (res.data.hasOwnProperty('public')) {
                            //需要修改密钥，再次提交
                            that.publicKey = res.data.public
                            that.publicMd5 = res.data.public_md5
                            //再次调用
                            that.doRegister()
                        } else {
                            //将jwt存入local
                            that.setJwt(res.data.jwt)
                            //删除cert
                            localStorage.removeItem('cert')
                            that.$router.push({
                                path: '/register-success'
                            })
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped="scoped">
.div-bg {
    background-image: url(../../assets/images/login_bg.png);
    border: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}

.formItemDesc {
    font-size: 12px;
    padding: 0;
    margin: 0;
    line-height: 20px;
    text-align: left;
    color: #999999;
}

.go-login {
    color: #00a4e0;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/register/UsernameAndPassword.vue